import React, {PureComponent} from "react"
import {get} from "lodash"

import Button from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import mfaService from "@irati/auth/services/mfa"
import GenericErrorCodes from "@irati/utils/services/errorCodes/Generic"
import Link from "@irati/ui/src/Link"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {mfaTracking} from "@irati-tracking/platform"

import {Modal} from "../BaseModal"
import {Screens, selectScreen} from "./index"
import {ButtonContainer} from "./styled"

interface Props extends InjectIntl {
  selectScreen: selectScreen,
  onCancel(): void,
  show: boolean
}

interface State {
  submit: Promise<any> | null
}

class MFAPopupRequest extends PureComponent<Props, State> {
  state: State = {
    submit: null
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.show === false && this.props.show === true) {
      mfaTracking.popupShown()
    }
  }

  handleSuccess = () => {
    const submit = mfaService
      .request()
      .then((mfa) => {
        const phoneNumber = mfa.phoneNumberLastDigits
        this.props.selectScreen(Screens.ENTER, {phoneNumber})
        mfaTracking.popupRequestCode()
      })
      .catch((err) => {
        const errorCode = getErrorCode(err)
        const codes = [GenericErrorCodes.PBAUTHMFAUserNotFound, GenericErrorCodes.PBMFASetupRequired]
        if (codes.includes(errorCode)) {
          return this.props.selectScreen(Screens.SETUP)
        }
        throw err
      })
    this.setState({submit})
  }

  handleCancel = () => {
    this.props.onCancel()
    mfaTracking.popupCancel()
  }

  render() {
    const {show, formatMessage} = this.props
    return (
      <Modal show={show} header="platform.mfa.request.title">
        <Body>
          <FormattedMessage
            id="platform.mfa.request.bodyWithUrl"
            values={{
              url: (
                <Link href={formatMessage({id: "platform.mfa.request.href"})}>
                  <FormattedMessage id="platform.mfa.request.hrefText" />
                </Link>
              )
            }} />
        </Body>
        <ButtonContainer>
          <Button tertiary onClick={this.handleCancel} id="mfa_request_buttonCancel" marginRight={2}>
            <FormattedMessage id="platform.mfa.request.cancel" />
          </Button>
          <Button onClick={this.handleSuccess} primary load={this.state.submit}>
            <FormattedMessage id="platform.mfa.request.submit" />
          </Button>
        </ButtonContainer>
      </Modal>
    )
  }
}

export default injectIntl(MFAPopupRequest)

function getErrorCode(data: any) {
  const apiCode = get(data, "extra.error.response.code")
  const graphCode = get(data, "extra.error.response.errors[0].errorCode")
  const apolloNetworkCode = get(data, "networkError.errorCode")

  return apiCode || graphCode || apolloNetworkCode
}
